import styled from '@emotion/styled';
import { Variables } from '../variables';

export const Bar = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 2px;
    background: ${Variables.Swatches.Gray3};
    border: 1px solid ${Variables.Swatches.Gray3};
    border-radius: 8px;
    flex-wrap: wrap;
`;

export const Chip = styled.button<{ active?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    white-space: nowrap;
    font-weight: ${props => (props.active ? 600 : 500)};
    font-size: 13px;
    line-height: 1;
    padding: 7px 11px 6px;
    border-radius: 6px;
    border: none;
    background: ${props => (props.active ? 'white' : 'transparent')};
    box-shadow: ${props => (props.active ? '0 1px 2px rgba(0,0,0,0.06)' : 'none')};
    color: ${props => (props.active ? '#0f172a' : '#94a3b8')};
    transition: background 120ms ease-out, color 120ms ease-out;

    &:disabled {
        opacity: 0.6;
        cursor: default;
    }

    svg {
        fill: currentColor;
    }
`;

export const Count = styled.span<{ active?: boolean }>`
    font-weight: 600;
    font-size: 11px;
    line-height: 1;
    color: inherit;
    opacity: ${props => (props.active ? 1 : 0.7)};
    font-variant-numeric: tabular-nums;
`;
